import React from "react";
import { Switch } from "@/components/ui/switch";

interface StatusCellProps {
    isActive: boolean;
    onToggle: () => void;
}

export const StatusCell: React.FC<StatusCellProps> = ({ isActive, onToggle }) => {
    return (
        <div className="flex items-center justify-center">
            <Switch checked={isActive} onCheckedChange={onToggle} />
        </div>
    );
};
